import { render, staticRenderFns } from "./Conference.vue?vue&type=template&id=b5256a3e&scoped=true"
import script from "./Conference.vue?vue&type=script&lang=ts"
export * from "./Conference.vue?vue&type=script&lang=ts"
import style0 from "./Conference.vue?vue&type=style&index=0&id=b5256a3e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5256a3e",
  null
  
)

export default component.exports